<template>
  <div class="cell__wrapper">
    <div
      class="cell"
      @click="expandHandler"
    >
      <div
        v-if="cellData.extandable && showExpandIcon"
        class="cell__expand-icon-wrapper"
      >
        <div
          class="cell__expand-icon"
          v-html="expandIcon"
        />
      </div>
      <div v-if="deleteColumn" class="cell__delete-wrapper">
        <div
          class="cell__delete-icon"
          @click.stop="$emit('delete')"
          v-html="deleteIcon"
        />
      </div>
      <div v-else-if="cellData.type === 'button'">
        <q-btn :label="cellData.value" @click.stop="$emit('btn-click')" />
      </div>
      <div v-else-if="cellData.format">
        {{ cellData.format(cellData.value) }}
      </div>
      <div v-else-if="cellData.type === 'boolean'">
        {{ cellData.value.toString() }}
      </div>
      <div
        v-else
        :class="['cell__value', {'extandable': cellData.extandable && showExpandIcon}]"
      >
        {{ cellData.value }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Ячейка строки
 * @module Shared/Component/Table/Cell
 * @requires Images/icon/ic-plus.svg
 * @requires Images/icon/ic-remove.svg
 * @requires Images/icon/ic-delete.svg
 * @vue-prop {Object} cellData - данные для отображения
 * @vue-prop {Boolean} showExpandIcon - показывать ли иконку раскрытия элемента
 * @vue-prop {Boolean} expanded - открыт ли элемент
 * @vue-prop {Boolean} deleteColumn - ячейка с иконкой удаления
 * @vue-computed {String} expandIcon - возвращает иконку для отображения
 * */

import icPlus from 'Images/icon/ic-plus.svg'
import icRemove from 'Images/icon/ic-remove.svg'
import deleteIcon from 'Images/icon/ic-delete.svg'

export default {
  name: 'Cell',
  props: {
    cellData: {
      type: Object,
      default: () => {}
    },
    showExpandIcon: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    deleteColumn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deleteIcon
    }
  },
  computed: {
    expandIcon() {
      return this.expanded ? icRemove : icPlus
    }
  },
  methods: {
    /**
     * Обработчик раскрытия элемента
     */
    expandHandler() {
      if (this.cellData.extandable) this.$emit('toggle-expanded')
    }
  }
}
</script>

<style lang="scss" scoped>
.cell {
  box-sizing: border-box;
  padding: 5px;
  min-height: 32px;
  height: 100%;
  position: relative;
  background-color: white;
  box-shadow: 0px 0px 0px 1px $table-border-color;

   &__wrapper {
    margin-top: 1px;
    margin-right: 1px;
    width: 100%;

    &:last-child {
      margin-right: 0px;
    }
  }

  &__expand-icon-wrapper {
    position: absolute;
  }

  &__expand-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  &__value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.extandable {
      margin-left: 30px;
    }
  }

  &__delete-icon {
    width: 30px;
    height: 30px;

    cursor: pointer;
  }

  &__delete-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
